"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHomeInsurance = function IconHomeInsurance(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m25 4.586 11 11V33h-2V16.415l-9-9-9 8.999V19h-2v-3.414zM26 17h5v7h-5zm4 6v-5h-3v5zm-26.295.414A1.42 1.42 0 1 0 6.29 24.59a1.42 1.42 0 0 0-2.585-1.176m.91.414a.42.42 0 1 1 .765.348.42.42 0 0 1-.765-.348M.319 20.08H7.99v14.59H5.56v2h4.43v-1.669h.597a4.2 4.2 0 0 1 2.136.665l.169.115 6.429 5.953.373.35c.367.35.714.694 1.034 1.024l.105.109.424.452A1 1 0 0 0 22 44h13l.12-.007.173-.026a2.9 2.9 0 0 0 2.375-3.027l-.003-.175c-.064-1.337-1.1-2.517-2.5-2.751L35.008 38l-7.24-.06h-.185a2 2 0 0 1-1.125-.38l-6.317-5.42-.06-.075c-.162-.245-.137-.643.118-.9l.09-.075a.73.73 0 0 1 .845.003l.088.074 4.79 4.79.138.127a2.73 2.73 0 0 0 3.715-.125l.128-.137a2.73 2.73 0 0 0-.124-3.717l-8.862-8.863-.157-.183a9 9 0 0 0-.879-.859c-.66-.564-1.329-.966-2.022-1.127A2.7 2.7 0 0 0 17.33 21H9.99v-2.92H.736a24 24 0 0 0-.417 2M9.99 23v10h.609a6.2 6.2 0 0 1 3.27 1.026l.24.166.09.074 6.48 6c.401.37.782.74 1.138 1.097l.46.47.159.167h12.481l.07-.012c.383-.094.661-.432.683-.877v-.125a1 1 0 0 0-.725-.975l-.057-.013-7.086-.059a4 4 0 0 1-2.364-.66l-.219-.15-6.438-5.524a2.73 2.73 0 0 1 .004-3.854 2.73 2.73 0 0 1 3.261-.446l.175.108.02.01q.09.048.18.12l.086.08 4.918 4.918a.73.73 0 0 0 1.026.004.73.73 0 0 0 .078-.938l-.076-.09-8.89-8.89-.071-.079-.105-.122-.114-.126a7 7 0 0 0-.602-.58c-.437-.374-.854-.624-1.174-.698l-.089-.017L17.33 23z",
    clipRule: "evenodd"
  })));
};

export { IconHomeInsurance, IconHomeInsurance as default };
